<template>
  <TextBlob>
    <template #heading> </template>
    <template #text>
      <div class="flex flex-col justify-evenly text-center h-auto">
        <transition name="fade" mode="out-in">
          <PulseLoader v-if="loading" />
          <ExperienceReview
            v-else-if="reviewStore.currentComponent == 'ExperienceReview'"
          />
          <FeedbackRequest
            v-else-if="reviewStore.currentComponent == 'FeedbackRequest'"
          />
          <PaymentOptions
            v-else-if="reviewStore.currentComponent == 'PaymentOptions'"
          />
          <PaymentProgress
            v-else-if="reviewStore.currentComponent == 'PaymentProgress'"
          />
          <ThankYou v-else-if="reviewStore.currentComponent == 'ThankYou'" />
        </transition>
      </div>
    </template>
  </TextBlob>
</template>
<script setup>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import TextBlob from "@/components/TextBlob.vue";
import api from "@/composables/api";
import { useRoute } from "vue-router";

import { useReview } from "@/stores";
const reviewStore = useReview();

import PaymentProgress from "@/views/ReviewView/PaymentProgress.vue";
import PaymentOptions from "@/views/ReviewView/PaymentOptions.vue";
import ExperienceReview from "@/views/ReviewView/ExperienceReview.vue";
import FeedbackRequest from "@/views/ReviewView/FeedbackRequest.vue";
import ThankYou from "@/views/ReviewView/ThankYou.vue";

import { ref } from "vue";

function determineComponent() {
  if (
    reviewStore.reviewStatus === "reviewed" &&
    (reviewStore.invoiceStatus === "paid" ||
      reviewStore.invoiceStatus === "not created" ||
      reviewStore.invoiceStatus === "claimed paid")
  ) {
    console.log("determineComponent: ThankYou");
    return "ThankYou";
  }

  console.log(
    "determineComponent: reviewStore.isReviewFirst",
    reviewStore.settings.isReviewFirst
  );
  if (reviewStore.settings.isReviewFirst) {
    if (reviewStore.reviewStatus === "new") {
      return "ExperienceReview";
    } else if (
      reviewStore.reviewStatus === "reviewed" &&
      reviewStore.invoiceStatus === "unpaid"
    ) {
      return "PaymentOptions";
    } else {
      return "ThankYou";
    }
  } else {
    // log invoiceStatus
    console.log("determineComponent: invoiceStatus", reviewStore.invoiceStatus);
    // log reviewStatus
    console.log("determineComponent: reviewStatus", reviewStore.reviewStatus);
    if (reviewStore.invoiceStatus === "unpaid") {
      return "PaymentOptions";
    } else if (reviewStore.reviewStatus === "new") {
      return "ExperienceReview";
    } else {
      return "ThankYou";
    }
  }
}

const loading = ref(true);
//check for reviewId in query params, use that to get review if it exists

function getReviewIdAndFetchData() {
  const route = useRoute(); // Get access to the current route

  // Try to get the reviewId from the query parameters
  let reviewId = route.query.reviewId;

  // If not found in query params, use the last node of the URL path
  if (!reviewId) {
    const pathSegments = route.path.split("/").filter(Boolean);
    reviewId = pathSegments[pathSegments.length - 1];
  }

  const checkValue = route.query.check;

  // Call fetchReviewerData with the determined reviewId
  fetchReviewerData(reviewId, checkValue);
}
//console.log("reviewStore", reviewStore.settings);
getReviewIdAndFetchData();

function fetchReviewerData(hashId, checkValue) {
  console.log("fetchReviewerData", hashId, checkValue);
  if (checkValue) {
    api(`v1/reviewer/checkSuccess/${checkValue}`).then((response) => {
      console.log("checkSuccess", response);
      handleResponseStatus(response);
      console.log("currentComponent", reviewStore.currentComponent);
      loading.value = false;
      return;
    });
  } else {
    api(`v1/reviewer/find/${hashId}`)
      .then(async (response) => {
        console.log("find:::", response.data.settings);

        // await new Promise((resolve) => setTimeout(resolve, 2000));
        await handleResponseStatus(response);
        // add delay for testing
        loading.value = false;
      })
      .catch((error) => {
        loading.value = false;
      });
  }

  reviewStore.currentComponent = determineComponent();

  // api(`v1/reviewer/find/${hashId}`)
  //   .then((response) => {
  //     handleResponseStatus(response);
  //     if (response.status === 200) {
  //       // updateReviewStore(response.data);
  //     }
  //     loading.value = false;
  //   })
  //   .catch((error) => {
  //     console.error(error);
  //     loading.value = false;
  //   });
}

async function handleResponseStatus(response) {
  switch (response.status) {
    case 200:
      reviewStore.invoiceStatus = response.data.invoiceStatus;
      reviewStore.invoiceAmount = response.data.invoiceAmount;
      reviewStore.invoiceCardAmount = response.data.invoiceCardAmount;
      reviewStore.reviewStatus = response.data.reviewerStatus;
      Object.assign(reviewStore.settings, response.data.settings);
      // console.log("object assign store:", reviewStore.settings);
      console.log("object assign store:", reviewStore.settings.isReviewFirst);
      reviewStore.currentComponent = determineComponent();
    case 404:
      // Handle not found
      break;
    case 500:
      reviewStore.currentComponent = "ThankYou";
      break;
    // Add more cases as needed
    default:
      console.log("default response", response);
      // Handle other statuses or default case
      break;
  }
}

// Attach event listener
setInterval(() => {
  reviewStore.sendClickEvents();
}, 15000); // 15 seconds

window.addEventListener("beforeunload", reviewStore.sendClickEvents);
//TODO: clean this up properly
// // Cleanup
// onBeforeUnmount(() => {
//   reviewStore.sendClickEvents();
//   console.log("unmounted");
//   window.removeEventListener("beforeunload", reviewStore.sendClickEvents);
// });

// // Cleanup
// onBeforeUnmount(() => {
//   console.log("unmounting");
//   reviewStore.sendClickEvents();
//   console.log("unmounted");
// });

// reviewStore.hashId = useRoute().params.reviewId;
// api(`v1/reviewer/find/${reviewStore.hashId}`)
//   .then((response) => {
//     //TODO: these need to be detailed, like a 404 for not found reviewer, 500 for server error, etc
//     if (response.status === 500) {
//       reviewStore.currentComponent = "ThankYou";
//       loading.value = false;
//       return;
//     }

//     const {
//       invoiceStatus,
//       invoiceAmount,
//       invoiceCardAmount,
//       reviewStatus,
//       stripeLink,
//       settings,
//       feedbackSubmitted,
//     } = response.data;
//     Object.assign(reviewStore, {
//       invoiceStatus,
//       invoiceAmount,
//       invoiceCardAmount,
//       reviewStatus,
//       stripeLink,
//       settings,
//       feedbackSubmitted,
//     });
//     reviewStore.currentComponent = determineComponent(
//       settings,
//       invoiceStatus,
//       reviewStatus
//     );

//     loading.value = false;
//   })
//   .catch((error) => {
//     console.error(error);
//     loading.value = false;
//   });

// function updateReviewStore(data) {
//   const {
//     invoiceStatus,
//     invoiceAmount,
//     invoiceCardAmount,
//     reviewStatus,
//     stripeLink,
//     squarePaymentLink,
//     settings,
//     feedbackSubmitted,
//   } = data;
//   Object.assign(reviewStore, {
//     invoiceStatus,
//     invoiceAmount,
//     invoiceCardAmount,
//     reviewStatus,
//     stripeLink,
//     squarePaymentLink,
//     settings,
//     feedbackSubmitted,
//   });
//   reviewStore.settings = settings;
//   reviewStore.currentComponent = determineComponent(
//     settings,
//     invoiceStatus,
//     reviewStatus
//   );
// }
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to

/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
